import { isErrorFileState } from '../models/file-state';
export var overrideMediaTypeIfUnknown = function overrideMediaTypeIfUnknown(fileState, mediaType) {
  if (!isErrorFileState(fileState) && fileState.mediaType === 'unknown') {
    return {
      mediaType: mediaType
    };
  }
  return {};
};